import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import tradeRequestApi from '../../sources/api/tradeRequestApi';

// constants
import { REJECT_TRADE_OFFER } from '../../constants/tradeOffersTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { REJECT_TRADE_OFFER_ERROR, REJECT_TRADE_OFFER_SUCCESS } from '../../constants/messages';

export function* rejectTradeOffer(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(REJECT_TRADE_OFFER, call(tradeRequestApi.rejectTradeOffer, params));
    yield toastr.success('success', REJECT_TRADE_OFFER_SUCCESS);
  } catch (e) {
    if (e.response) {
      yield toastr.error(e.response.body.message);
    } else {
      yield toastr.error(REJECT_TRADE_OFFER_ERROR);
    }

    yield put(error(REJECT_TRADE_OFFER, e));
  } finally {
    yield put(doneIndicator(REJECT_TRADE_OFFER));
  }
}

export function* watchRejectTradeOffer() {
  yield takeEvery(REJECT_TRADE_OFFER, rejectTradeOffer);
}

export default function* root() {
  yield all([
    fork(watchRejectTradeOffer)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tradeOffers/rejectTradeOffer.js